import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { BuildLog } from '@/types/buildlog';

async function fetchBuildLogs(deploymentId: string): Promise<BuildLog[]> {
  const response = await api.get<{ data: BuildLog[] }>(`/builds/${deploymentId}/logs`);
  return response.data.data || [];
}

export function useBuildLogs(deploymentId: string | undefined, enablePolling = false) {
  return useQuery({
    queryKey: ['buildLogs', deploymentId],
    queryFn: () => fetchBuildLogs(deploymentId!),
    enabled: !!deploymentId,
    refetchInterval: enablePolling ? 3000 : false, // Poll every 3 seconds when enabled
  });
}
